import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ContactUs } from './../../shared/services/contact-us/contact-us';
import { ContactUsService } from './../../shared/services/contact-us/contact-us.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { ErrorComponent, Helpers, InformationComponent } from 'src/app/shared/util/helpers';
import { catchError, finalize, map, switchMap } from 'rxjs/operators';
import { BlogService } from 'src/app/shared/services/blog/blog.service';
import { Blog } from 'src/app/shared/services/blog/blog';
import { BlogItemCommentService } from 'src/app/shared/services/blog-item-comment/blog-item-comment.service';
import { TrackerService } from 'src/app/shared/util/tracker.service';
import { SUBSCRIPTION_PRICES, SubscriptionPriceEnum } from 'src/app/shared/util/subscription-prices.enum';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {
  public contactItem: ContactUs = new ContactUs();
  public assistantHref: string = "";

  public latestBlogItems: Blog[] = [];

  subscriptionPrices = SUBSCRIPTION_PRICES;

  constructor(
    public snackBar: MatSnackBar,
    public contactUsService: ContactUsService,
    public blogService: BlogService,
    private router: Router,
    private blogItemCommentService: BlogItemCommentService,
    public translate: TranslateService,
    private trackerService: TrackerService
  ) {

  }

  ngOnInit(): void {
    this.contactItem.subject = '';
    this.contactItem.content = '';
    this.contactItem.email = '';
    this.contactItem.telephone = '';

    this.assistantHref = environment.assistantApp;

    this.trackerService.trackPageViews();

    Helpers.getObservable([])
      .pipe(
        switchMap(() => this.blogService.getLastThreeItems()),
        switchMap((blogItemList: Blog[]) => {
          // Step 2: For each blog item, fetch comments
          const blogItemsWithComments$ = blogItemList.map((item) =>
            this.blogItemCommentService.getCommentsByBlogItem(item.id).pipe(
              map((comments) => ({ ...item, commentsCount: comments ? comments.length : 0 }))
            )
          );
          return Helpers.getObservable(blogItemsWithComments$);
        }),
        catchError(
          error => {
            throw error;
          }
        ),
        finalize(() => {
        }),
      )
      .subscribe(
        results => {
          console.log('results:', results)
          this.latestBlogItems = results || [];
        },
        error => {

        }
      );
  }

  getSubscriptionPriceDetails(uniqueName: string) {
    const documentKey = Object.keys(this.subscriptionPrices).find(key =>
      key.toLowerCase().includes(uniqueName.toLowerCase())
    );

    return documentKey ? this.subscriptionPrices[documentKey as SubscriptionPriceEnum] : null;
  }

  isLoading: boolean = false;
  send(): void {
    // Log initial state
    console.log('Initial isLoading:', this.isLoading);

    // Validate form fields
    if (!this.contactItem.subject || !this.contactItem.email || !this.contactItem.content) {
      this.snackBar.openFromComponent(ErrorComponent, {
        data: { message: 'Vă rugăm să completați toate câmpurile.' },
        duration: 2000,
      });
      return;
    }

    // Explicitly set loading state to true
    this.isLoading = true;
    console.log('After setting isLoading:', this.isLoading);

    this.contactItem.date = new Date();

    // Use setTimeout to simulate potential async behavior and verify loading state
    this.contactUsService.addItem(this.contactItem)
      .pipe(
        finalize(() => {
          // Ensure loading state is set to false after request completes
          this.isLoading = false;
          console.log('In finalize, isLoading:', this.isLoading);
        })
      )
      .subscribe(
        results => {
          console.log('Success, isLoading:', this.isLoading);
          
          // Reset form fields
          this.contactItem.subject = '';
          this.contactItem.email = '';
          this.contactItem.content = '';

          // Show success message
          this.snackBar.openFromComponent(InformationComponent, {
            data: { message: 'Mesajul a fost trimis cu succes!' },
            duration: 2000,
          });
        },
        error => {
          console.log('Error, isLoading:', this.isLoading);
          
          // Show error message
          this.snackBar.openFromComponent(ErrorComponent, {
            data: { message: 'A apărut o eroare. Vă rugăm să încercați din nou.' },
            duration: 2000,
          });
        }
      );
  }

  navigateToBlogPost(id: number): void {
    this.router.navigate(['/blog-post', id]);
  }
}
